import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-24 md:py-32 bg-sage-500 overflow-hidden" data-id="element-12">
      {/* Soft decorative blurs */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-13">
        <div className="absolute top-[-20%] left-[-10%] w-[400px] h-[400px] bg-sage-400 rounded-full blur-[120px] opacity-40" data-id="element-14" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[400px] h-[400px] bg-sage-600 rounded-full blur-[120px] opacity-30" data-id="element-15" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="font-serif italic text-4xl md:text-5xl lg:text-6xl text-cream-50 mb-8 leading-tight" data-id="element-18">
            Tu cuero cabelludo <br className="hidden md:block" data-id="element-19" />
            merece calma.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-20">
          <p className="text-sage-100 text-lg md:text-xl max-w-xl mx-auto mb-10 leading-relaxed" data-id="element-21">
            No más buscar en Google a las 2am. No más champús que no funcionan.
            Solo un plan claro que funciona.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-22">
          <button onClick={scrollToPricing} className="group bg-white hover:bg-cream-50 text-sage-600 text-lg font-medium px-10 py-4 rounded-full transition-all duration-300 shadow-lg shadow-sage-600/30 hover:shadow-sage-600/40 inline-flex items-center gap-2" data-id="element-23">
            Quiero mi protocolo
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-24" />
          </button>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-25">
          <p className="mt-8 text-sage-200 text-sm tracking-wide" data-id="element-26">
            Acceso inmediato · Garantía de 30 días · Pago seguro
          </p>
        </FadeIn>
      </div>
    </section>;
}